import { Menu, MenuItem, MenuButton } from '@szhsin/react-menu';
import '@szhsin/react-menu/dist/index.css';
import MenuIcon from '@mui/icons-material/Menu';
import PropTypes from 'prop-types';
import { UserImg } from './style';
import { OPTION_MENU } from '../../../../constants/menu';

export default function MenuButtonHomePage({ onClick }) {
  const onSelectMenu = (value) => {
    onClick(value);
  };
  return (
    <Menu
      menuButton={
        <MenuButton className="ButtonDisplay">
          <MenuIcon />
          <UserImg />
        </MenuButton>
      }>
      <MenuItem onClick={() => onSelectMenu(OPTION_MENU.LOGIN)}>Login</MenuItem>
      <MenuItem onClick={() => onSelectMenu(OPTION_MENU.JOIN_AS_VENUE)}>Join as a Venue</MenuItem>
      <MenuItem onClick={() => onSelectMenu(OPTION_MENU.JOIN_AS_VENDOR)}>Join as a Vendor</MenuItem>
    </Menu>
  );
}

MenuButtonHomePage.propTypes = {
  onClick: PropTypes.func.isRequired,
};
